var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedia24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9099A3",
    fillRule: "evenodd",
    d: "M64.843 2.467a3.401 3.401 0 011.407-.303 3.414 3.414 0 013.42 3.42 3.35 3.35 0 01-.694 2.068l-.05.063-3.029 3.962h3.823v1.514h-6.9l.001-.002h-.001l4.895-6.396.05-.064c.24-.315.38-.706.38-1.135a1.912 1.912 0 00-1.906-1.905c-.26 0-.507.052-.732.147a1.913 1.913 0 00-1.148 1.747h-.025v.01h-1.527a3.42 3.42 0 012.037-3.126zm11.337 8.439h.013v3.419H62.049L55.261 1.014h20.932v8.365h-1.906V1.948l-.013.017V1.96l-6.85 8.958h5.336v2.271h1.514v-2.283h1.906v-.001zm-64.283-9.88L7.14 7.787 2.384 1.025H.479v13.311h1.905V4.331l4.756 6.763 4.757-6.763v10.005h1.905V1.026h-1.905zm15.216 1.892V1.025H15.695v13.311H27.1v-1.905h-9.5v-3.81h7.608V6.716H17.6V2.918h9.513zm3.798 9.513h4.756a4.76 4.76 0 004.757-4.756 4.76 4.76 0 00-4.757-4.757h-4.756v9.513zM29.006 1.025h6.661a6.663 6.663 0 016.662 6.662c0 3.672-2.99 6.65-6.662 6.65h-6.661V1.024zm16.742 0h-1.905v13.311h1.905V1.026zm8.87 2.095l-3.003 5.892h6.006l.971 1.905h-7.948l-1.742 3.42H46.77l6.775-13.312 1.073 2.095zm15.897 6.27l2.245-2.94v2.94h-2.245z",
    clipRule: "evenodd"
  })));
}

export default SvgMedia24;